<ng-template cdkPortalOutlet></ng-template>


// WEBPACK FOOTER //
// /app/node_modules/@angular/material/dialog/typings/index.d.ts.MatDialogContainer.html